/* eslint-disable no-console */
import {
  CONSOLE_BUFFER_SIZE,
  CONSOLE_ENTRY_MAX_LENGTH
} from 'data/error-log-constants';
import { ConsoleEntryType, ConsoleLevelType } from 'types/error-log';
import { nextSequence } from 'utils/error-log/sequence';
import { safeStringify, truncateString } from 'utils/error-log/serialize';

const LEVELS: ConsoleLevelType[] = ['log', 'info', 'warn', 'error', 'debug'];
const ARG_MAX_LENGTH = 1000;

const entries: ConsoleEntryType[] = [];
let installed = false;

function formatArgs(args: unknown[]): string {
  return args.map((arg) => safeStringify(arg, ARG_MAX_LENGTH)).join(' ');
}

export function recordConsoleEntry(level: ConsoleLevelType, args: unknown[]) {
  entries.push({
    id: nextSequence(),
    timestamp: Date.now(),
    level,
    message: truncateString(formatArgs(args), CONSOLE_ENTRY_MAX_LENGTH)
  });
  if (entries.length > CONSOLE_BUFFER_SIZE) {
    entries.shift();
  }
}

export function installConsoleRecorder() {
  if (installed) {
    return;
  }
  installed = true;
  LEVELS.forEach((level) => {
    const original = console[level].bind(console);
    console[level] = (...args: unknown[]) => {
      recordConsoleEntry(level, args);
      original(...args);
    };
  });
}

export function getConsoleSnapshot(): ConsoleEntryType[] {
  return [...entries];
}

export function resetConsoleRecorder() {
  entries.length = 0;
}
